import { render, staticRenderFns } from "./setVideo.vue?vue&type=template&id=2b326ff8&scoped=true&"
import script from "./setVideo.vue?vue&type=script&lang=js&"
export * from "./setVideo.vue?vue&type=script&lang=js&"
import style0 from "./setVideo.vue?vue&type=style&index=0&id=2b326ff8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b326ff8",
  null
  
)

export default component.exports